import { Country as ServerCountry } from 'server/models/Country';

export { CountryData, CountryOptions } from 'server/models/Country';

export class Country extends ServerCountry {
    static SortOrder = (c1 : Country, c2 : Country) =>
        c1. SortOrder() !== c2.SortOrder() ? c1.SortOrder() - c2.SortOrder()
        : c1.Name() < c2.Name() ? -1
        : c1.Name() > c2.Name() ? 1
        : 0;
}


// WEBPACK FOOTER //
// ./data/models/Country.ts